import { useNavigate } from 'react-router-dom';
import { useCreateSchoolyear } from 'queries/schoolyears/useCreateSchoolyear';
import { useCurrentSchoolyearIdSchoolId } from 'queries/schoolyears/atom';
import { routes } from 'containers/routes';
import { Schoolyear } from 'types/schoolyear';
import { CreateSchoolyearOptions } from 'containers/MesAnneesScolaires/types';

export function useCreateSchoolyearAndNavigate() {
  const navigate = useNavigate();
  const { createSchoolyear } = useCreateSchoolyear();
  const { setCurrentSchoolyearIdSchoolId } = useCurrentSchoolyearIdSchoolId();

  const createSchoolyearAndNavigate = (payload: {
    schoolyear: Schoolyear;
    options: CreateSchoolyearOptions;
  }) =>
    createSchoolyear(payload).then(() => {
      const createdSchoolyearId = payload.schoolyear.id;
      const createdSchoolId = payload.schoolyear.schools[0].id;
      setCurrentSchoolyearIdSchoolId({
        schoolyearId: createdSchoolyearId,
        schoolId: createdSchoolId,
      });
      return navigate(`${routes.schoolyearsSettings}/${createdSchoolyearId}`);
    });

  return { createSchoolyearAndNavigate };
}
